import PreviewFooter from '@/components/preview/PreviewFooter'

export default function Footer() {
  return <PreviewFooter />
}
